<template>
     <!-- main section -->
  <section class="hero is-flex main">
    <div class="bg-img">
      <div class="img1 icon"><img src="../assets/images/stars.png" alt=""></div>
      <div class="img2 icon"><img src="../assets/images/book.png" alt=""></div>
      <div class="img3 icon"><img src="../assets/images/rocket.png" alt=""></div>
      <div class="img4 icon"><img src="../assets/images/cloud3.png" alt=""></div>
      <div class="img5 icon"><img src="../assets/images/award.png" alt=""></div>
      <div class="img6 icon"><img src="../assets/images/apple.png" alt=""></div>
      <div class="img7 icon"><img src="../assets/images/rainbow2.png" alt=""></div>
      <div class="img8 icon"><img src="../assets/images/butterfly2.png" alt=""></div>
      <div class="img9 icon"><img src="../assets/images/elephant.png" alt=""></div>
      <div class="img10 icon"><img src="../assets/images/ball.png" alt=""></div>
    </div>
    
    <b-loading :is-full-page="false" :active.sync="isLoading" />
    
    <div class="title">{{ dashboardTitle }}</div>
    <div v-if="getUserType == 'A'" class="admin-dashboard">
      <p class="admin-subtitle">Welcome back! Pick a section to manage.</p>
      <div class="admin-grid">
        <div
          v-for="(card, i) in showCards"
          :key="i"
          class="admin-card"
          :style="`--card-color: ${card.styles.card_color}`"
          @click="goTo(card.router_name)"
          role="button"
          tabindex="0"
          @keyup.enter="goTo(card.router_name)"
        >
          <div class="admin-card-icon">
            <img v-if="card.img" :src="card.img" :alt="card.name" />
          </div>
          <div class="admin-card-body">
            <div class="admin-card-title">{{ card.name }}</div>
            <div class="admin-card-desc">{{ card.description }}</div>
          </div>
          <div class="admin-card-arrow" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </div>
        </div>
      </div>
    </div>
    <div class="container flex " v-if="getUserType == 'P'">
      <div v-if="!isLoading && fetchKids.length" class="kids-grid">
        <div v-for="(card, i) in userCards" :key="`kid-${i}`" @click="$router.push({ name: 'kiddetail_practice', params: card.router_params })" 
             class="kid-card" :style="`background: linear-gradient(135deg, ${card.styles.card_color}20, ${card.styles.card_color}40)`">
            <div class="kid-avatar" :style="`background: linear-gradient(135deg, ${card.styles.card_color}, ${shadeColor(card.styles.card_color, 20)})`">
              <div class="avatar-icon">
                <span>{{ card.name.charAt(0).toUpperCase() }}</span>
              </div>
              <div class="floating-shapes">
                <div class="shape shape-1" :style="`background: ${card.styles.card_color}60`"></div>
                <div class="shape shape-2" :style="`background: ${card.styles.card_color}40`"></div>
                <div class="shape shape-3" :style="`background: ${card.styles.card_color}30`"></div>
              </div>
            </div>
            <div class="kid-info">
              <div class="kid-name">{{ card.name }}</div>
              <div class="kid-subtitle">Ready to Learn!</div>
            </div>
            <div class="card-decorations">
              <div class="decoration star" :style="`color: ${card.styles.card_color}`">⭐</div>
              <div class="decoration heart" :style="`color: ${card.styles.card_color}`">💖</div>
              <div class="decoration rocket" :style="`color: ${card.styles.card_color}`">🚀</div>
            </div>
        </div>
      </div>
      <!-- Empty State for New Users -->
      <div v-else-if="!isLoading && fetchKids.length === 0" class="empty-state">
        <div class="welcome-container">
          <div class="mascot-section">
            <div class="logo-circle">
              <img class="mascot-image" :src="require('@/assets/images/UP_SKOOL_LOGO.png')" alt="Up-skool mascot" />
            </div>
            <div class="welcome-emoji">👋</div>
          </div>
          
          <div class="welcome-content">
            <h2 class="welcome-title">Welcome to Up-skool!</h2>
            <p class="welcome-subtitle">Add your first child to start the learning journey</p>
            
            <div class="onboarding-form">
              <div class="form-step">
                <div class="input-wrapper">
                  <span class="input-icon">👶</span>
                  <input
                    v-model="kid_name"
                    type="text"
                    placeholder="Child's name"
                    class="kid-input"
                  />
                </div>
              </div>
              
              <div class="form-step">
                <div class="input-wrapper">
                  <span class="input-icon">📅</span>
                  <input
                    v-model="kid_dob"
                    type="date"
                    placeholder="Date of birth"
                    class="kid-input"
                  />
                </div>
              </div>
              
              <button
                @click="addKid()"
                class="cta-button"
                :disabled="!kid_name.trim() || !kid_dob || isLoading"
                :class="{ 'loading': isLoading }"
              >
                <span v-if="!isLoading">🚀 Start Learning</span>
                <span v-else>Creating Profile...</span>
              </button>
            </div>
            
            <div class="info-badges">
              <div class="badge">📚 Interactive Learning</div>
              <div class="badge">🎯 Fun Quizzes</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// var timetable = new Timetable();
export default {
  name: "Home",
  components: {},
  data() {
    return {
      kid_name : "",
      kid_dob : "",
      isLoading : false,
      user_cards: [
      ],
    };
  },
  methods: {
    ...mapActions(["loadKids", "createKid"]),
    goTo(name){
      if(name) this.$router.push({ name })
    },
    shadeColor(color, percent) {
      var R = parseInt(color.substring(1, 3), 16);
      var G = parseInt(color.substring(3, 5), 16);
      var B = parseInt(color.substring(5, 7), 16);

      R = parseInt((R * (100 + percent)) / 100);
      G = parseInt((G * (100 + percent)) / 100);
      B = parseInt((B * (100 + percent)) / 100);

      R = R < 255 ? R : 255;
      G = G < 255 ? G : 255;
      B = B < 255 ? B : 255;

      var RR = R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
      var GG = G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
      var BB = B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

      return "#" + RR + GG + BB;
    },
    addKid(){
      this.isLoading = true
      this.createKid({
        token : this.getTeacherToken,
        kid : {
          name : this.kid_name,
          dob : this.kid_dob
        }
      }).then(() => {
        this.$buefy.toast.open({
              message: "Hurray! Lets get started now!",
              type: "is-success",
            });
        this.$confetti.start();
        setTimeout(() => {
          this.$confetti.stop();
        }, 3000);
      }).finally(() => {
        this.isLoading = false
      })
    }
  },
  computed: {
    ...mapGetters([
      "getUserType",
      "getTeacherToken",
      "fetchMenu",
      "fetchAdministratorMenu",
      "fetchColors",
      "fetchKids",
    ]),
    dashboardTitle(){
      if(this.isLoading) return ""

      const title = "Dashboard"
      
      return title
    },
    showCards() {
      if (this.getUserType == "T") return this.fetchMenu;
      else if (this.getUserType == "A") return this.fetchAdministratorMenu;
      
      //If nothing is true return nothing
      return [];
    },
    userCards() {
      const colors_length = this.fetchColors.length;
      let kid_cards = [];
      for (let kid_index in this.fetchKids) {
        let kid = this.fetchKids[kid_index];
        kid_cards.push({
          name: kid.name,
          title_size: "is-2",
          styles: {
            card_color: this.fetchColors[colors_length - 1 - kid_index],
          },
          router_params: {
            kid_id: kid._id,
          },
        });
      }
      return [...this.user_cards, ...kid_cards];
    },
  },
  created() {
    this.isLoading = true
    if(this.getUserType=="SA"){
      this.$router.push({
          name : 'school-home'
      })
    }
    this.loadKids({
      token: this.getTeacherToken,
    }).finally(() => {
      this.isLoading = false
    }) 
  },
};
</script>
<style scoped>
.input-container {
  border: 1px solid #c2c2c2;
  border-radius: 0.5rem;
  padding: 10px 10px;
  width: 100%;
  min-width : 300px;
  margin: 20px 0;
  position: relative;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 4%;
}
.input-container input {
  all: unset;
  flex: 1;
  width: 100%;
}
.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.container {
  position: relative;
}

.bg-img {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.bg-img div {
  display: flex;
  position: absolute;
  width: auto;
}

.title {
  position: relative;
  z-index: 2;
  font-size: clamp(1.75rem, 3.2vw, 2.6rem) !important;
  font-weight: 800 !important;
  letter-spacing: -0.02em;
  margin: 0 0 0.25rem !important;
  text-align: center;
  background: linear-gradient(135deg, #8919e7 0%, #4361ee 60%, #31c8ff 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  line-height: 1.1;
}

img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.button {
  flex-direction: row;
  padding: 1vw 1.25vw;
  width: 100%;
  background: #8919e7;
  border-radius: 1vw;
  color: #fff;
  gap: 1vw;
  cursor: pointer;
  position: relative;
  text-transform: capitalize;
}
.button.outline {
  border: 0.063rem solid #8919e7;
  background: #fff;
  color: #000;
}
.link {
  cursor: pointer;
}

.main {
  align-items: center;
  margin: 0;
  position: relative;
  gap: 0.75rem;
}
/* responsive page*/

/* tablet */
@media screen and (max-width: 1023px) {
  /* title scales via clamp() */
}

/* Mobiles */
@media screen and (max-width: 767px) {
  /* title scales via clamp() */
}

@media screen and (max-width: 467px){
  /* title scales via clamp() */
}
/* background image */
.bg-img .icon {
  max-width: 7vw;
  height: auto;
}
.bg-img .img1 {
  top: 10%;
  left: 5%;
  animation: float 6s ease-in-out infinite;
}
.bg-img .img2 {
  top: 50%;
  right: 13.5%;
  animation: float 4s ease-in-out infinite;
}
.bg-img .img3 {
  top: 66.33%;
  left: 21.7%;
  animation: float 5s ease-in-out infinite;
}
.bg-img .img4 {
  top: 36.33%;
  right: 7.625%;
  animation: float 7s ease-in-out infinite;
}
.bg-img .img5 {
  top: 54.44%;
  left: 7.4375%;
  animation: float 3s ease-in-out infinite;
}
.bg-img .img6 {
  top: 51.67%;
  left: 18.6%;
  animation: float 8s ease-in-out infinite;
}
.bg-img .img7 {
  top: 25%;
  right: 25%;
  animation: float 6s ease-in-out infinite;
}
.bg-img .img8 {
  top: 15%;
  left: 35%;
  animation: float 4.5s ease-in-out infinite;
}
.bg-img .img9 {
  bottom: 20%;
  right: 40%;
  animation: float 5.5s ease-in-out infinite;
}
.bg-img .img10 {
  top: 80%;
  left: 60%;
  animation: float 3.5s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
}
.logo-container {
  margin-left: 60px;
}
/* main section */
.main {
  padding: clamp(1rem, 2.5vw, 2rem) clamp(0.75rem, 2vw, 1.5rem) clamp(2rem, 5vw, 3.5rem);
  margin: 0;
  min-height: auto;
}

.main::after {
  content: '';
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 40vh;
  max-height: 420px;
  background-image: url(../assets/images/cloud2.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom center;
  pointer-events: none;
  z-index: 1;
}
.main .page-title {
  font-weight: 600;
  font-size: 36px;
  line-height: 45px;
}
.main .container .box {
  display: flex;
  align-items: center;
  gap: 2vw;
  width: 100%;
  max-width: 34.26vw;
  background: #ffffff;
  border: 1px solid #dddddd;
  box-shadow: 0px 20px 40px rgb(0 0 0 / 13%);
  border-radius: 1.1vw;
  padding: 2vw;
  margin: 0;
  cursor:pointer;
}
.main .container .icon {
  width: 2vw;
  height: auto;
}
.main .container .box-title {
  font-weight: 600;
  font-size: 2vw;
  color: #202020;
  text-transform: capitalize;
}

.main .container .box:hover {
  border-color: #8919e7;
}
.main .container {
  width: 100%;
  gap: 3.73vw;
  justify-content: flex-start;
}

/* responsive page*/

/* tablet */
@media screen and (max-width: 1024px) {
  .main .container .box {
    box-shadow: 0px 15px 20px rgb(0 0 0 / 13%);
  }
}

/* Mobiles */
@media screen and (max-width: 767px) {
  .main .container .box {
    padding: 3.5vw;
  }
}

#onboarding-kid{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 50px;
}

#mascot-image{
  height: 300px;
  width: 300px;
}

/* Admin Dashboard */
.admin-dashboard {
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 0 auto;
  padding: 0 0.5rem;
}

.admin-subtitle {
  text-align: center;
  font-size: 0.95rem;
  color: #64748b;
  margin: 0 0 1rem;
}

.admin-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.9rem;
  width: 100%;
}

@media screen and (max-width: 900px) {
  .admin-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
  }
}

.admin-card {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.75rem;
  padding: 1.4rem 1.4rem 1.25rem;
  min-height: 180px;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
  outline: none;
}

.admin-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: var(--card-color, #8919e7);
  transition: height 0.25s ease;
}

.admin-card::after {
  content: '';
  position: absolute;
  bottom: -60px;
  right: -60px;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: var(--card-color, #8919e7);
  opacity: 0.07;
  transition: transform 0.4s ease, opacity 0.25s ease;
  pointer-events: none;
}

.admin-card:hover,
.admin-card:focus-visible {
  transform: translateY(-5px);
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.12);
  border-color: var(--card-color, #8919e7);
}

.admin-card:hover::before,
.admin-card:focus-visible::before {
  height: 6px;
}

.admin-card:hover::after,
.admin-card:focus-visible::after {
  transform: scale(1.3);
  opacity: 0.13;
}

.admin-card-icon {
  flex: 0 0 auto;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: linear-gradient(135deg, var(--card-color, #8919e7), rgba(255, 255, 255, 0.25));
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.14);
  position: relative;
  z-index: 1;
}

.admin-card-icon img {
  width: 30px;
  height: 30px;
  object-fit: contain;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15));
}

.admin-card-body {
  flex: 1 1 auto;
  min-width: 0;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.admin-card-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
  line-height: 1.25;
  letter-spacing: -0.01em;
}

.admin-card-desc {
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.admin-card-arrow {
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(15, 23, 42, 0.04);
  color: #94a3b8;
  z-index: 1;
  transition: background 0.25s ease, color 0.25s ease, transform 0.25s ease;
}

.admin-card:hover .admin-card-arrow,
.admin-card:focus-visible .admin-card-arrow {
  background: var(--card-color, #8919e7);
  color: #ffffff;
  transform: translateX(2px) translateY(-2px);
}

@media screen and (max-width: 768px) {
  .admin-dashboard {
    padding: 0.5rem 1rem 1.5rem;
  }
  .admin-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .admin-card {
    padding: 1.15rem;
    min-height: 160px;
  }
  .admin-card-icon {
    width: 50px;
    height: 50px;
    border-radius: 14px;
  }
  .admin-card-icon img {
    width: 26px;
    height: 26px;
  }
  .admin-card-title {
    font-size: 1.05rem;
  }
  .admin-card-desc {
    font-size: 0.825rem;
  }
}

/* Kids Grid */
.kids-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2.5rem;
  width: 100%;
  max-width: 1200px;
  padding: 2rem 0;
}

/* Kid Card Styling */
.kid-card {
  position: relative;
  padding: 2rem;
  border-radius: 25px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 2px solid transparent;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.kid-card:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

/* Kid Avatar */
.kid-avatar {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.avatar-icon {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 50%;
}

.avatar-icon span {
  font-size: 2rem;
  font-weight: 700;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Floating Shapes */
.floating-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.shape {
  position: absolute;
  border-radius: 50%;
  animation: floatShape 4s ease-in-out infinite;
}

.shape-1 {
  width: 12px;
  height: 12px;
  top: 15%;
  left: 20%;
  animation-delay: -1s;
}

.shape-2 {
  width: 8px;
  height: 8px;
  top: 70%;
  right: 15%;
  animation-delay: -2s;
}

.shape-3 {
  width: 6px;
  height: 6px;
  bottom: 20%;
  left: 15%;
  animation-delay: -3s;
}

@keyframes floatShape {
  0%, 100% { 
    transform: translateY(0px) rotate(0deg); 
    opacity: 0.6;
  }
  50% { 
    transform: translateY(-15px) rotate(180deg); 
    opacity: 1;
  }
}

/* Kid Info */
.kid-info {
  margin-bottom: 1rem;
}

.kid-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  text-transform: capitalize;
}

.kid-subtitle {
  font-size: 0.9rem;
  color: #7f8c8d;
  font-weight: 500;
  opacity: 0.8;
}

/* Card Decorations */
.card-decorations {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

.decoration {
  position: absolute;
  font-size: 1.2rem;
  animation: decorationFloat 3s ease-in-out infinite;
  opacity: 0.7;
}

.decoration.star {
  top: 15%;
  right: 15%;
  animation-delay: -0.5s;
}

.decoration.heart {
  bottom: 20%;
  left: 10%;
  animation-delay: -1.5s;
}

.decoration.rocket {
  top: 20%;
  left: 15%;
  animation-delay: -2.5s;
}

@keyframes decorationFloat {
  0%, 100% { 
    transform: translateY(0px) rotate(0deg); 
    opacity: 0.7;
  }
  50% { 
    transform: translateY(-10px) rotate(10deg); 
    opacity: 1;
  }
}

/* Hover Effects */
.kid-card:hover .kid-avatar {
  transform: scale(1.1);
  animation: avatarPulse 0.6s ease-in-out;
}

.kid-card:hover .floating-shapes .shape {
  animation-duration: 2s;
}

.kid-card:hover .decoration {
  animation-duration: 1.5s;
  opacity: 1;
}

@keyframes avatarPulse {
  0%, 100% { transform: scale(1.1); }
  50% { transform: scale(1.2); }
}

/* Responsive Styles */
@media screen and (max-width: 768px) {
  .kids-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 1rem 0;
  }
  
  .kid-card {
    padding: 1.5rem;
    min-height: 180px;
  }
  
  .kid-avatar {
    width: 60px;
    height: 60px;
    margin-bottom: 1rem;
  }
  
  .avatar-icon span {
    font-size: 1.5rem;
  }
  
  .kid-name {
    font-size: 1.3rem;
  }
  
  .kid-subtitle {
    font-size: 0.8rem;
  }
  
  .decoration {
    font-size: 1rem;
  }
  
  .bg-img .icon {
    max-width: 10vw;
  }
}

@media screen and (max-width: 480px) {
  .kids-grid {
    gap: 1rem;
  }
  
  .kid-card {
    padding: 1rem;
    min-height: 160px;
  }
  
  .kid-avatar {
    width: 50px;
    height: 50px;
  }
  
  .avatar-icon span {
    font-size: 1.2rem;
  }
  
  .kid-name {
    font-size: 1.1rem;
  }
}

/* Empty State Styles */
.empty-state {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

.welcome-container {
  background: linear-gradient(135deg, #ffffff 0%, #f8faff 100%);
  border-radius: 20px;
  padding: 3rem;
  text-align: center;
  box-shadow: 0 12px 40px rgba(137, 25, 231, 0.1);
  border: 1px solid rgba(137, 25, 231, 0.1);
  position: relative;
  overflow: hidden;
}

.welcome-container::before {
  content: '';
  position: absolute;
  top: -50px;
  right: -50px;
  width: 100px;
  height: 100px;
  background: linear-gradient(45deg, rgba(137, 25, 231, 0.1), rgba(137, 25, 231, 0.05));
  border-radius: 50%;
}

.mascot-section {
  margin-bottom: 2rem;
  position: relative;
}

.logo-circle {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #8919e7, #6b38c7);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  box-shadow: 0 8px 25px rgba(137, 25, 231, 0.3);
}

.mascot-image {
  width: 60px;
  height: 60px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.welcome-emoji {
  font-size: 2rem;
  position: absolute;
  top: -10px;
  right: calc(50% - 60px);
  animation: wave 2s ease-in-out infinite;
}

@keyframes wave {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(20deg); }
  75% { transform: rotate(-10deg); }
}

.welcome-content {
  position: relative;
  z-index: 2;
}

.welcome-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #8919e7, #6b38c7);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.welcome-subtitle {
  font-size: 1.1rem;
  color: #64748b;
  margin-bottom: 2rem;
}

.onboarding-form {
  max-width: 380px;
  margin: 0 auto 2rem;
}

.form-step {
  margin-bottom: 1.2rem;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: white;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  transition: all 0.3s ease;
  overflow: hidden;
}

.input-wrapper:focus-within {
  border-color: #8919e7;
  box-shadow: 0 0 0 3px rgba(137, 25, 231, 0.1);
}

.input-icon {
  padding: 0 1rem;
  font-size: 1.2rem;
  background: linear-gradient(135deg, #8919e7, #6b38c7);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.empty-state .input-container {
  position: relative;
  border: none;
  border-radius: 0;
  padding: 0;
  background: transparent;
  box-shadow: none;
  margin: 0;
  gap: 0;
}

.kid-input {
  flex: 1;
  padding: 1rem;
  border: none;
  outline: none;
  font-size: 1rem;
  background: transparent;
  color: #374151;
}

.kid-input::placeholder {
  color: #9ca3af;
}

.cta-button {
  width: 100%;
  padding: 1.2rem 2rem;
  background: linear-gradient(135deg, #8919e7, #6b38c7);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 0.5rem;
  box-shadow: 0 6px 20px rgba(137, 25, 231, 0.3);
}

.cta-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(137, 25, 231, 0.4);
}

.cta-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.info-badges {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
  flex-wrap: wrap;
}

.badge {
  background: rgba(137, 25, 231, 0.1);
  color: #8919e7;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid rgba(137, 25, 231, 0.2);
}


/* Empty State Responsive Design */
@media screen and (max-width: 768px) {
  .welcome-container {
    padding: 2rem 1.5rem;
    margin: 1rem;
  }
  
  .welcome-title {
    font-size: 1.5rem;
  }
}

@media screen and (max-width: 480px) {
  .empty-state {
    padding: 1rem;
  }
  
  .welcome-container {
    padding: 1.5rem 1rem;
  }
  
  .welcome-title {
    font-size: 1.3rem;
  }
  
  .welcome-subtitle {
    font-size: 0.9rem;
  }
}
</style>